import { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import buildLink from "../../../../urls";
import MessageAlert from "../../../../components/messageAlert";
import hocStarredPage from "../../../../components/hocStarredPage";
import { PlaySounds } from "../../../../functions/playSounds";
import { axiosServer } from "../../../../axiosServer";

const Resolvev2 = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const codePr = useRef(null);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  async function handleSubmit() {
    setLoading(true);
    const userID = getUserIdFromLocalStorage();
    const url = buildLink("updateReturnOrderProduct");
    const return_order_product_id = codePr.current.value;
    const return_status_id = 40;
    const user_id = userID;
    const type = "";

    const obj = {
      return_order_product_id,
      return_status_id,
      type: type,
      user_id,
    };

    try {
      await axiosServer.put(url, obj).then((res) => {
        if (res.data.success) {
          setLoading(false);
          if (codePr.current) {
            codePr.current.value = "";
          }
          playSuccessSound();
          setMessage(res.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          setLoading(false);
          setMessage(res.data.message);
          playErrorSound();
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
      });
    } catch (e) {
      setLoading(false);
      setMessage(e.response.data.message);
      playErrorSound();
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  useEffect(() => {
    codePr.current.focus();
  }, []);

  const handleTrashClick = () => {
    codePr.current.value = "";
    codePr.current.focus();
  };

  return (
    <>
      <div className=" h-full  bg-white ">
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Resolve Stock Mistake</h2>
            </div>
          </div>
        </div>

        <div className="container flex flex-col gap-5">
          <div>
            <div className="mb-1">Rerturn Order Product ID</div>
            <div className=" flex flex-row justify-center gap-3 ">
              <div className="relative flex-1">
                <input
                  ref={codePr}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Rerturn Order Product"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit(e);
                    }
                  }}
                />
                <div>
                  <FaTrash
                    onClick={() => handleTrashClick()}
                    className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex flex-row gap-3">
            {" "}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className={`w-full py-2 text-white ${
                loading ? "bg-dgreySeller cursor-not-allowed" : "bg-dbase"
              }`}
            >
              Submit
            </button>{" "}
          </div>
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(Resolvev2);
